import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
	selector: 'au-load-progress-bar',
	templateUrl: './au-load-progress-bar.component.html',
	styleUrls: ['./au-load-progress-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgStyle],
})
export class AuLoadProgressBarComponent {
	@Input() set width(width: number) {
		this.withInPercents = `${width}%`;
	}

	withInPercents: string;
}
